export interface ComicChapter {
  id: string;
  title: string;
  views: number;
  updateTime: string;
}

export interface Comic {
  id: string;
  title: string;
  category: string;
  author: string;
  cover: string;
  status: string;
  intro: string;
  tags: string[];
  views: number;
  likes: number;
  rating: number;
  episodes: number;
  updateTime: string;
  chapters: ComicChapter[];
}

export interface Category {
  key: string;
  name: string;
  desc: string;
  icon: string;
}

export const categories: Category[] = [
  {
    key: "mengxi",
    name: "萌系漫画",
    desc: "软萌角色、可爱画风，治愈你的每一天",
    icon: "ri-heart-2-line",
  },
  {
    key: "tianchong",
    name: "甜宠漫画",
    desc: "高甜预警，宠溺日常甜到齁",
    icon: "ri-cake-3-line",
  },
  {
    key: "lianai",
    name: "恋爱漫画",
    desc: "怦然心动的少女恋爱物语",
    icon: "ri-flower-line",
  },
];

export const authors = [
  {
    name: "茶茶",
    works: 6,
    fans: 12,
    tag: "甜宠担当",
    cover: "https://readdy.ai/api/search-image?query=cute%20anime%20girl%20illustration%20avatar%20with%20soft%20pastel%20pink%20background%2C%20adorable%20chibi%20style%2C%20sweet%20smile%2C%20clean%20dreamy%20romantic%20manga%20art&width=500&height=500&seq=author-tea&orientation=squarish",
  },
  {
    name: "团子酱",
    works: 9,
    fans: 18,
    tag: "萌系画师",
    cover: "https://readdy.ai/api/search-image?query=cute%20anime%20girl%20illustration%20avatar%20holding%20a%20round%20dango%20dumpling%2C%20soft%20pastel%20cream%20background%2C%20adorable%20chibi%20manga%20art%2C%20gentle%20smile&width=500&height=500&seq=author-dango&orientation=squarish",
  },
  {
    name: "小星星",
    works: 4,
    fans: 8,
    tag: "恋爱高手",
    cover: "https://readdy.ai/api/search-image?query=cute%20anime%20girl%20illustration%20avatar%20with%20starry%20night%20background%2C%20soft%20pastel%20tones%2C%20adorable%20dreamy%20manga%20art%2C%20sparkling%20eyes&width=500&height=500&seq=author-star&orientation=squarish",
  },
  {
    name: "奶糖工坊",
    works: 7,
    fans: 15,
    tag: "治愈日常",
    cover: "https://readdy.ai/api/search-image?query=cute%20anime%20girl%20illustration%20avatar%20with%20sweet%20candy%20and%20cream%20tones%2C%20soft%20pastel%20background%2C%20adorable%20manga%20art%2C%20cozy%20vibe&width=500&height=500&seq=author-milk&orientation=squarish",
  },
];

const chapters = (base: string, count: number, startViews: number, startDate: string): ComicChapter[] => {
  const list: ComicChapter[] = [];
  for (let i = 1; i <= count; i += 1) {
    list.push({
      id: `${base}-${i}`,
      title: `第${i}话`,
      views: Math.max(1200, startViews - (count - i) * 1800),
      updateTime: `${startDate}`,
    });
  }
  return list;
};

export const comics: Comic[] = [
  {
    id: "1",
    title: "心动甜点屋",
    category: "甜宠漫画",
    author: "茶茶",
    cover: "https://readdy.ai/api/search-image?query=cute%20anime%20girl%20holding%20a%20strawberry%20cake%20inside%20a%20cozy%20pink%20patisserie%20shop%2C%20soft%20pastel%20dreamy%20romantic%20atmosphere%2C%20adorable%20manga%20cover%20illustration%2C%20clean%20composition%20with%20warm%20lighting&width=500&height=700&seq=cov-xin-dong&orientation=portrait",
    status: "连载中",
    intro: "转学后的苏小棠误打误撞进入一家只卖甜点的神奇小店，老板是个温柔又傲娇的少年。在这里，每一份甜品都藏着一段心动故事，而她的味蕾和心跳，也被一点点甜化了。",
    tags: ["甜宠", "校园", "美食"],
    views: 986000,
    likes: 12400,
    rating: 9.6,
    episodes: 56,
    updateTime: "今日更新",
    chapters: chapters("1", 12, 986000, "今日更新"),
  },
  {
    id: "2",
    title: "软萌同桌攻略",
    category: "萌系漫画",
    author: "团子酱",
    cover: "https://readdy.ai/api/search-image?query=two%20adorable%20anime%20school%20kids%20sitting%20side%20by%20side%20at%20a%20classroom%20desk%2C%20one%20girl%20shy%20blushing%2C%20soft%20pastel%20colors%2C%20cute%20chibi%20manga%20cover%20illustration%2C%20gentle%20dreamy%20school%20setting&width=500&height=700&seq=cov-tongzhuo&orientation=portrait",
    status: "连载中",
    intro: "软萌少女林小软的新同桌是个高冷学霸，两人从互不搭理到慢慢靠近。高冷学霸被软萌性格一点点攻陷，教科书级的甜宠日常就此展开。",
    tags: ["萌系", "校园", "日常"],
    views: 752000,
    likes: 9800,
    rating: 9.4,
    episodes: 48,
    updateTime: "昨日更新",
    chapters: chapters("2", 12, 752000, "昨日更新"),
  },
  {
    id: "3",
    title: "恋恋咖啡时光",
    category: "恋爱漫画",
    author: "小星星",
    cover: "https://readdy.ai/api/search-image?query=cute%20anime%20girl%20barista%20serving%20a%20cup%20of%20coffee%20in%20a%20warm%20cozy%20cafe%2C%20steaming%20drink%2C%20soft%20pastel%20romantic%20atmosphere%2C%20adorable%20manga%20cover%20illustration%2C%20clean%20elegant%20composition&width=500&height=700&seq=cov-coffee&orientation=portrait",
    status: "已完结",
    intro: "开在老街角落的咖啡店，每天都会迎来一位固定客人。店员少女和常客少年之间，隔着拉花与奶泡的距离，慢慢靠近彼此的心。一杯咖啡的时间，足以让爱情悄悄发酵。",
    tags: ["恋爱", "日常", "治愈"],
    views: 631000,
    likes: 8700,
    rating: 9.2,
    episodes: 40,
    updateTime: "3天前",
    chapters: chapters("3", 12, 631000, "3天前"),
  },
  {
    id: "4",
    title: "傲娇房东与猫",
    category: "甜宠漫画",
    author: "奶糖工坊",
    cover: "https://readdy.ai/api/search-image?query=tsundere%20anime%20girl%20landlady%20cuddling%20a%20fluffy%20cat%20on%20a%20cozy%20sofa%2C%20soft%20pastel%20warm%20tones%2C%20adorable%20manga%20cover%20illustration%2C%20dreamy%20domestic%20romance%20scene&width=500&height=700&seq=cov-fangdong&orientation=portrait",
    status: "连载中",
    intro: "搬家第一天就被房东的猫扑了个满怀。傲娇房东嘴上说着嫌弃，却在每一次收房租时偷偷多给他带一杯奶茶。甜甜的合租日常，从一只猫开始。",
    tags: ["甜宠", "同居", "日常"],
    views: 521000,
    likes: 7600,
    rating: 9.3,
    episodes: 33,
    updateTime: "今日更新",
    chapters: chapters("4", 12, 521000, "今日更新"),
  },
  {
    id: "5",
    title: "星星打翻的夜晚",
    category: "恋爱漫画",
    author: "小星星",
    cover: "https://readdy.ai/api/search-image?query=cute%20anime%20girl%20sitting%20under%20a%20starry%20night%20sky%20full%20of%20glowing%20stars%2C%20dreamy%20soft%20pastel%20tones%2C%20romantic%20adorable%20manga%20cover%20illustration%2C%20magical%20nighttime%20atmosphere&width=500&height=700&seq=cov-stars&orientation=portrait",
    status: "连载中",
    intro: "天文社少女沈星星在天台上和沉默寡言的少年约好一起数星星。每一颗划过的流星，都是她不敢说出口的心动。原来喜欢一个人，就像不小心打翻了整片星河。",
    tags: ["恋爱", "青春", "校园"],
    views: 468000,
    likes: 6900,
    rating: 9.5,
    episodes: 45,
    updateTime: "2天前",
    chapters: chapters("5", 12, 468000, "2天前"),
  },
  {
    id: "6",
    title: "甜甜圈少女日记",
    category: "萌系漫画",
    author: "团子酱",
    cover: "https://readdy.ai/api/search-image?query=chibi%20anime%20girl%20happily%20holding%20colorful%20donuts%2C%20playful%20cute%20style%2C%20soft%20pastel%20cream%20background%2C%20adorable%20manga%20cover%20illustration%2C%20cheerful%20sweet%20mood&width=500&height=700&seq=cov-donut&orientation=portrait",
    status: "已完结",
    intro: "元气满满的少女开了一家甜甜圈小店，每天用甜甜圈治愈路过的人。直到某天，一个只点原味甜甜圈的奇怪客人出现，她的日常开始悄悄改变。",
    tags: ["萌系", "美食", "日常"],
    views: 389000,
    likes: 5200,
    rating: 9.0,
    episodes: 36,
    updateTime: "1周前",
    chapters: chapters("6", 12, 389000, "1周前"),
  },
  {
    id: "7",
    title: "捡到一只小奶团",
    category: "萌系漫画",
    author: "奶糖工坊",
    cover: "https://readdy.ai/api/search-image?query=cute%20anime%20girl%20cradling%20a%20tiny%20baby%20chick%20in%20her%20hands%2C%20adorable%20and%20fluffy%2C%20soft%20pastel%20tones%2C%20cute%20manga%20cover%20illustration%2C%20warm%20gentle%20lighting&width=500&height=700&seq=cov-naituan&orientation=portrait",
    status: "连载中",
    intro: "在放学路上捡到一只浑身软乎乎的小奶团（其实是会说话的神秘生物）。从此少女的日常鸡飞狗跳又无比治愈，原来养一只小奶团，能收获一整年的快乐。",
    tags: ["萌系", "奇幻", "治愈"],
    views: 447000,
    likes: 8300,
    rating: 9.6,
    episodes: 29,
    updateTime: "今日更新",
    chapters: chapters("7", 12, 447000, "今日更新"),
  },
  {
    id: "8",
    title: "樱花初恋物语",
    category: "恋爱漫画",
    author: "茶茶",
    cover: "https://readdy.ai/api/search-image?query=cute%20anime%20girl%20standing%20under%20falling%20cherry%20blossom%20petals%2C%20spring%20romance%2C%20soft%20pastel%20pink%20tones%2C%20adorable%20manga%20cover%20illustration%2C%20dreamy%20fresh%20spring%20atmosphere&width=500&height=700&seq=cov-sakura&orientation=portrait",
    status: "连载中",
    intro: "每年樱花季，少女都会在樱花树下许愿。今年，她遇到了一个同样在树下等樱花的少年。樱花落尽的季节，他们的初恋才刚刚开始。",
    tags: ["恋爱", "校园", "青春"],
    views: 514000,
    likes: 7200,
    rating: 9.3,
    episodes: 52,
    updateTime: "昨日更新",
    chapters: chapters("8", 12, 514000, "昨日更新"),
  },
  {
    id: "9",
    title: "甜品店的秘密心动",
    category: "甜宠漫画",
    author: "茶茶",
    cover: "https://readdy.ai/api/search-image?query=anime%20boy%20and%20girl%20looking%20through%20a%20dessert%20shop%20window%20together%2C%20both%20blushing%2C%20soft%20pastel%20sweet%20atmosphere%2C%20adorable%20manga%20cover%20illustration%2C%20romantic%20cozy%20mood&width=500&height=700&seq=cov-mi-mi&orientation=portrait",
    status: "已完结",
    intro: "两位青梅竹马各自开在街对面的甜品店，表面互相较劲，私下却偷偷品尝对方做的点心。店名悄悄变成对方的名字，是这场甜宠里藏得最深的秘密。",
    tags: ["甜宠", "美食", "青梅竹马"],
    views: 356000,
    likes: 6100,
    rating: 9.1,
    episodes: 38,
    updateTime: "2周前",
    chapters: chapters("9", 12, 356000, "2周前"),
  },
  {
    id: "10",
    title: "呆萌学霸恋爱手册",
    category: "萌系漫画",
    author: "团子酱",
    cover: "https://readdy.ai/api/search-image?query=cute%20anime%20schoolgirl%20wearing%20glasses%20with%20a%20stack%20of%20books%20and%20a%20notebook%2C%20soft%20pastel%20classroom%20background%2C%20adorable%20manga%20cover%20illustration%2C%20gentle%20smart%20and%20cute%20mood&width=500&height=700&seq=cov-xueba&orientation=portrait",
    status: "连载中",
    intro: "年级第一的呆萌学霸，能把所有公式倒背如流，却完全读不懂喜欢一个人的信号。直到同桌递给她一本《恋爱手册》，她开始一本正经地学习心动。",
    tags: ["萌系", "校园", "学霸"],
    views: 298000,
    likes: 4700,
    rating: 9.2,
    episodes: 41,
    updateTime: "3天前",
    chapters: chapters("10", 12, 298000, "3天前"),
  },
  {
    id: "11",
    title: "月光下的告白",
    category: "恋爱漫画",
    author: "小星星",
    cover: "https://readdy.ai/api/search-image?query=anime%20boy%20confessing%20love%20to%20a%20cute%20girl%20under%20soft%20moonlight%20in%20a%20park%2C%20romantic%20night%20scene%2C%20soft%20pastel%20tones%2C%20adorable%20manga%20cover%20illustration%2C%20gentle%20sweet%20mood&width=500&height=700&seq=cov-gaobai&orientation=portrait",
    status: "连载中",
    intro: "少年在月光最亮的那个夜晚，把所有说不出口的话都说了出来。少女红着脸接过他手里的星星灯，答应的那一声，让整片月光都变得温柔。",
    tags: ["恋爱", "校园", "告白"],
    views: 431000,
    likes: 6600,
    rating: 9.4,
    episodes: 37,
    updateTime: "今日更新",
    chapters: chapters("11", 12, 431000, "今日更新"),
  },
  {
    id: "12",
    title: "每天都想黏着你",
    category: "甜宠漫画",
    author: "奶糖工坊",
    cover: "https://readdy.ai/api/search-image?query=cute%20anime%20couple%20cuddling%20together%20affectionately%2C%20fluffy%20and%20adorable%2C%20soft%20pastel%20tones%2C%20sweet%20manga%20cover%20illustration%2C%20warm%20cozy%20romantic%20mood&width=500&height=700&seq=cov-nian&orientation=portrait",
    status: "连载中",
    intro: "他们从互相嫌弃到形影不离，恋爱后的每一天都甜度爆表。黏人精少女和傲娇少年之间的日常，看一百话都不会腻。",
    tags: ["甜宠", "日常", "同居"],
    views: 672000,
    likes: 10800,
    rating: 9.5,
    episodes: 60,
    updateTime: "昨日更新",
    chapters: chapters("12", 12, 672000, "昨日更新"),
  },
];

export const heroComic = comics[0];

export const faqItems = [
  {
    q: "可可漫画网是免费的吗？",
    a: "是的，可可漫画网上的萌系漫画、甜宠漫画和恋爱漫画都可以在线免费阅读，无需下载客户端，点开即可看。部分热门连载会在每周定时更新新话数。",
  },
  {
    q: "漫画多久更新一次？",
    a: "我们坚持每日更新，热门连载通常每周更新1到2话，完结作品会一次性放出全集。你可以通过首页的「今日更新」板块第一时间看到最新话。",
  },
  {
    q: "如何找到自己喜欢的漫画？",
    a: "网站按萌系漫画、甜宠漫画、恋爱漫画做了清晰分类，你也可以通过顶部搜索框输入漫画名、作者或标签关键词快速定位，还能在热门排行里发现大家都在追的作品。",
  },
  {
    q: "可以在手机上看吗？",
    a: "可以。可可漫画网针对手机、平板和电脑做了自适应优化，无论在哪种设备上打开，都能获得流畅的阅读体验。",
  },
  {
    q: "想追的漫画不小心关掉了怎么办？",
    a: "建议你通过浏览器书签收藏正在追的漫画详情页，方便下次直接进入。我们也正在规划收藏与追更功能，敬请期待。",
  },
];

export const rankings = [...comics].sort((a, b) => b.views - a.views);